import api from '../config/api'
import { to } from '../utils/async'

let reporteesPromise = null;

const UserService = {
  getCurrent: () => (
    api.get(`${wbConfig.baseUrl}/restapi/user`)
  ),

  search: async ({ term = '', directOnly = false, teams = false, skipAttendees = [] }) => {
    const url = `${wbConfig.baseUrl}/restapi/meetings/search/users`
    const params = { term, directOnly, teams }
    const [err, result] = await to(api.get(url, { params, cancelable: true }))
    if (err) {
      return ['Could not get the list of users. Please try again']
    }
    if (!result || !result.data || !result.data.data) {
      return ['API response is misformatted. Please try again']
    }
    const {data: {data: items}} = result
    items = items.map(item => ({
      type: item.type,
      ...item.data,
      term
    }))
    items.sort((a, b) => {
      let nameA = (a.type === 'user' ? a.firstName : a.name).toLowerCase()
      let nameB = (b.type === 'user' ? b.firstName : b.name).toLowerCase()
      return nameA.localeCompare(nameB)
    })
    items.sort((a, b) => {
      let nameA = (a.type === 'user' ? a.firstName : a.name).toLowerCase()
      let nameB = (b.type === 'user' ? b.firstName : b.name).toLowerCase()
      let yesA = nameA.startsWith(term) ? 1 : 0
      let yesB = nameB.startsWith(term) ? 1 : 0
      return yesB - yesA
    })
    items.sort((a, b) => {
      if (a.type != 'team' && b.type == 'team') return 1
      else if (a.type == 'team' && b.type != 'team') return -1
      else return 0
    })
    if (skipAttendees.length) {
      const attendeeIds = skipAttendees.map(a => a.id)
      items = items.filter((item) => !attendeeIds.includes(item.id))
    }
    return [null, items]
  },
  getReportees: () => {
    if (reporteesPromise === null) {
      reporteesPromise = api.get(`${wbConfig.baseUrl}/team/userReporteesList`);
    }
    return reporteesPromise;
  },
  isDirectReportee: async (userId) => {
    try {
      const response = await UserService.getReportees();
      return response.data.userList?.some(
        (u) => userId === +u.userId && u.orgRole === '1'
      ) || false;
    }catch(e) {
      console.error('Error checking direct reportees:', error);
      return false;
    }
   
  }
}

export default UserService
